class VariantList extends HTMLElement
 {
  constructor() {
    super();
    this.imageEles = this.querySelectorAll('a');
    this.colorVariantTitleEle = this.querySelector('.js-color-variant-title');
    this.currentColorVariant = this.querySelector('.js-color-variant-title').textContent;

    this.initHover();
  }

  initHover() {
    this.imageEles.forEach((imageEle) => {
      imageEle.addEventListener('mouseover', this.handleHoverOver.bind(this));
      imageEle.addEventListener('mouseout', () => {
        console.log(this.colorVariantTitleEle.textContent, this.currentColorVariant);
        this.colorVariantTitleEle.textContent = this.currentColorVariant;
      });
    });
  }

  handleHoverOver(event) {
    console.log(event.target.getAttribute('data-color'));
    this.colorVariantTitleEle.textContent = event.target.getAttribute('data-color');

  }
}

window.customElements.define('variant-list', VariantList);
